module.exports = __webpack_public_path__ + "img/lr-cb66-100.877c835d.gif";